import { useState, createContext, useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { GlobalStyles } from "@mui/material";
import { useTranslation } from "react-i18next";
import { StyleSheetManager } from "styled-components";
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

import { muiTheme, GLOBAL_STYLES } from "../config/muiTheme";

// Create RTL cache
const cacheRTL = createCache({
  key: "muirtl",
  stylisPlugins: [rtlPlugin],
});

// Create LTR cache
const cacheLTR = createCache({
  key: "muiltr",
});

export const ThemeContext = createContext();

export const ThemeProviderWrapper = ({ children }) => {
  const { i18n } = useTranslation();
  const [theme, setTheme] = useState(muiTheme());

  useEffect(() => {
    const isRTL = i18n.language === "ar";
    const direction = isRTL ? "rtl" : "ltr";

    document.documentElement.dir = direction;
    document.documentElement.lang = i18n.language;

    setTheme(muiTheme(direction));
  }, [i18n.language]);

  return (
    <CacheProvider value={i18n.language === "ar" ? cacheRTL : cacheLTR}>
      <StyleSheetManager
        stylisPlugins={i18n.language === "ar" ? [rtlPlugin] : []}
      >
        <ThemeContext.Provider value={{ theme }}>
          <ThemeProvider theme={theme}>
            <GlobalStyles styles={GLOBAL_STYLES} />

            {children}
          </ThemeProvider>
        </ThemeContext.Provider>
      </StyleSheetManager>
    </CacheProvider>
  );
};
